// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-material {
  border: 1px solid #e2e2e2;
}

.hi {
  height: calc(100vh - 292px);
  overflow: auto;
}

.hi1 {
  height: calc(100vh - 242px);
  overflow: auto;
}

.eap-hi {
  height: calc(100vh - 294px);
  overflow: auto;
}

.eap-lo {
  height: calc(100vh - 172px);
  overflow: auto;
}

.lo {
  height: calc(100vh - 172px);
  overflow: auto;
}

.pe-2 {
  padding-right: 0.7rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/client-grid/client-grid.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,cAAA;AACJ;;AACA;EACI,2BAAA;EACA,cAAA;AAEJ;;AAAA;EACI,2BAAA;EACA,cAAA;AAGJ;;AADA;EACI,2BAAA;EACA,cAAA;AAIJ;;AAFA;EACI,2BAAA;EACA,cAAA;AAKJ;;AAHA;EACI,gCAAA;AAMJ","sourcesContent":[".ag-theme-material{\r\n    border: 1px solid #e2e2e2;\r\n}\r\n\r\n.hi{\r\n    height: calc(100vh - 292px);\r\n    overflow: auto;\r\n}\r\n.hi1{\r\n    height: calc(100vh - 242px);\r\n    overflow: auto;\r\n}\r\n.eap-hi{\r\n    height: calc(100vh - 294px);\r\n    overflow: auto;\r\n}\r\n.eap-lo{\r\n    height: calc(100vh - 172px);\r\n    overflow: auto;\r\n}\r\n.lo{\r\n    height: calc(100vh - 172px);\r\n    overflow: auto;\r\n}\r\n.pe-2 {\r\n    padding-right: .7rem !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
